import { Field } from '@base-ui/react/field';
import { Button } from '@/components/ui/Button';
import { Separator } from '@/components/ui/Separator';
import { useSettingsSaveBar } from '@/providers/settings/SettingsContext';

export const SettingsSaveBar = () => {
  const { applyChanges, dirty, lastSavedAgo, resetDefaults, updateProfile } =
    useSettingsSaveBar();

  return (
    <div className="sticky bottom-0 -mx-6 bg-background/80 px-6 py-4 backdrop-blur-md w-full left-0">
      <Separator className="absolute inset-x-0 top-0" />
      <div className="flex items-center justify-between">
        <p className="font-mono text-xs lg:text-sm text-subtle">
          {dirty ? (
            <>
              <span className="mr-1.5 inline-block size-1.5 animate-pulse rounded-full bg-score-mid align-middle" />
              <span className="text-score-mid">Unsaved changes</span>
              <span> · apply or discard before closing</span>
            </>
          ) : (
            <>
              <span className="mr-1.5 inline-block size-1.5 rounded-full bg-score-high align-middle" />
              All changes applied
              {lastSavedAgo != null && ` · last save ${lastSavedAgo}s ago`}
            </>
          )}
        </p>
        <div className="flex gap-1.5">
          <Button
            disabled={!dirty}
            onClick={resetDefaults}
            size="sm"
            type="button"
            variant="ghost"
          >
            Reset to defaults
          </Button>
          <Button
            disabled={!dirty}
            loading={updateProfile.isPending}
            onClick={applyChanges}
            size="sm"
            type="button"
            variant="primary"
          >
            Apply & restart daemon
          </Button>
        </div>
      </div>
      <Field.Root name="root">
        <Field.Error className="mt-2 block text-right font-mono text-xs lg:text-sm text-score-low" />
      </Field.Root>
    </div>
  );
};
